import { useEffect, useRef } from 'react';

// copy from https://overreacted.io/making-setinterval-declarative-with-react-hooks/

export default function useInterval(callback, delay, immediate = false) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            if (immediate) {
                tick();
            }
            const id = setInterval(tick, delay);
            /* eslint consistent-return: 0 */
            return () => clearInterval(id);
        }
    }, [delay, immediate]);
}
